import GoogleMap from "./GoogleMap";

export { default as rehydrator } from "./GoogleMap.rehydrator";
export default GoogleMap;
